module.exports = __webpack_public_path__ + "static/media/preview.4f6bfc84.webp";